import { ChromeCastBridge } from 'features/NativePlugins/Bridges/ChromeCastBridge'
import { registerPlugin } from 'features/NativePlugins/registerPlugin'

export class ChromeCastPlugin {
  bridge: ChromeCastBridge

  constructor() {
    this.bridge = registerPlugin('ChromeCastPlugin')
  }

  async checkAvailability(): Promise<boolean> {
    const data = await this.bridge.checkAvailability()
    return data.available
  }

  async isConnected(): Promise<boolean> {
    const data = await this.bridge.isConnected()
    return data.connected
  }

  async presentCastDialog(): Promise<void> {
    await this.bridge.presentCastDialog()
  }

  async loadMedia(
    mediaUrl: string,
    title?: string,
    imageUrl?: string,
    duration?: number,
    startTime?: number,
    isLive?: boolean,
    isDvr?: boolean
  ): Promise<void> {
    await this.bridge.loadMedia({
      mediaUrl,
      title,
      imageUrl,
      duration,
      startTime,
      isLive,
      isDvr
    })
  }

  async getCurrentSession(): Promise<boolean> {
    const data = await this.bridge.getCurrentSession()
    return data.sessionActive
  }

  async endCurrentSession(): Promise<void> {
    await this.bridge.endCurrentSession()
  }

  async playPause(): Promise<void> {
    await this.bridge.playPause()
  }

  async getCurrentTime(): Promise<number> {
    const data = await this.bridge.getCurrentTime()
    return data.currentTime
  }

  async getDuration(): Promise<number> {
    const data = await this.bridge.getDuration()
    return data.duration
  }

  async seek(time: number): Promise<void> {
    await this.bridge.seek({ time })
  }

  async setVolume(volume: number): Promise<void> {
    await this.bridge.setVolume({ volume })
  }

  async addListener(
    event: string,
    callback: (data: any) => void
  ): Promise<void> {
    await this.bridge.addListener(event, callback)
  }

  async removeListener(eventName: string): Promise<void> {
    await this.bridge.removeListener(eventName)
  }

  async removeAllListeners(): Promise<void> {
    await this.bridge.removeAllListeners()
  }

  onDurationUpdate(
    callback: (playing: boolean, progress: number, duration: number) => void
  ): void {
    this.bridge.addListener('chromecastDurationUpdated', (data) => {
      callback(data.playing, data.progress, data.duration)
    })
  }
}
